import React from "react"
import "./styles.css"
import { useScript } from "./useScript"

interface PaymentRequestInstance extends PaymentRequest {
  onmerchantvalidation: (event: any) => void
  onpaymentmethodchange: (event: any) => void
  onshippingoptionchange: (event: any) => void
  onshippingaddresschange: (event: any) => void
}

export default function ApplePay18() {
  useScript("https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js")

  const onApplePayButtonClicked = async () => {
    console.log("Apple Pay button clicked")
    if (!PaymentRequest) {
      console.log("Apple Pay Payment Request API is not supported")
      return
    }

    try {
      // Define PaymentMethodData
      const paymentMethodData = [
        {
          supportedMethods: "https://apple.com/apple-pay",
          data: {
            version: 3,
            merchantIdentifier: "merchant.com.apdemo",
            merchantCapabilities: ["supports3DS"],
            supportedNetworks: ["amex", "discover", "masterCard", "visa"],
            countryCode: "US"
          }
        }
      ]
      // Define PaymentDetails
      const paymentDetails = {
        total: {
          label: "Demo (Card is not charged)",
          amount: {
            value: "1.00",
            currency: "USD"
          }
        }
      }
      // Define PaymentOptions
      const paymentOptions = {
        requestPayerName: false,
        requestBillingAddress: false,
        requestPayerEmail: false,
        requestPayerPhone: false,
        requestShipping: false,
        shippingType: "shipping"
      }

      // Create PaymentRequest
      // @ts-ignore
      const request = new PaymentRequest(paymentMethodData, paymentDetails, paymentOptions) as PaymentRequestInstance

      request.onmerchantvalidation = (event) => {
        const body = {}
        const merchantSessionPromise = fetch("/authorizeMerchant")
          .then((res) => res.json()) // Parse the response as JSON.
          .catch((err) => {
            console.error("Error fetching merchant session", err)
          })

        event.complete(merchantSessionPromise)
      }

      request.onpaymentmethodchange = (event) => {
        console.log("Payment method change event", event)
        const paymentDetailsUpdate = {
          total: paymentDetails.total
        }
        event.updateWith(paymentDetailsUpdate)
      }

      request.onshippingoptionchange = (event) => {
        console.log("Shipping option change event", event)
        // Define PaymentDetailsUpdate based on the selected shipping option.
        // No updates or errors needed, pass an object with the same total.
        const paymentDetailsUpdate = {
          total: paymentDetails.total
        }
        event.updateWith(paymentDetailsUpdate)
      }

      request.onshippingaddresschange = (event) => {
        console.log("Shipping address change event", event)
        // Define PaymentDetailsUpdate based on a shipping address change.
        const paymentDetailsUpdate = {}
        event.updateWith(paymentDetailsUpdate)
      }

      const response = await request.show()
      const status = "success"
      await response.complete(status)
    } catch (e) {
      // Handle errors
      console.log("Error in Apple Pay Payment Request", e)
    }
  }

  React.useEffect(() => {
    const applePayElement = document.querySelector("apple-pay-button")
    if (!applePayElement) return
    applePayElement.addEventListener("click", onApplePayButtonClicked)
    return () => {
      applePayElement.removeEventListener("click", onApplePayButtonClicked)
    }
  }, [])

  return (
    <div className='apple-pay-page-v18'>
      <div
        dangerouslySetInnerHTML={{
          __html: `<apple-pay-button buttonstyle="black" type="plain" locale="en-US"></apple-pay-button>`
        }}
      ></div>
    </div>
  )
}
